import React, { useState, useEffect, useContext } from 'react'
import { Container, Button, Nav, Form, ProgressBar } from 'react-bootstrap'
import { useParams, useNavigate } from 'react-router-dom'
import { AuthContext } from '../AuthContext'
import Cookies from 'js-cookie'
import axios from 'axios'

// Import record components
import BloodPressureRecord from './BloodPressureRecord'
import BloodSugarRecord from './BloodSugarRecord'
import ExerciseRecord from './ExerciseRecord'
import WaterRecord from './WaterRecord'
import DefecationRecord from './DefecationRecord'
import SleepRecord from './SleepRecord'
import EmotionRecord from './EmotionRecord'

// Import Addrecord components
import AddBloodPressure from './AddForms/AddBloodPressure'
import AddBloodSugar from './AddForms/AddBloodSugar'
import AddExercise from './AddForms/AddExercise'
import AddWater from './AddForms/AddWater'
import AddDefecation from './AddForms/AddDefecation'
import AddSleep from './AddForms/AddSleep'
import AddEmotion from './AddForms/AddEmotion'
import { Helmet } from 'react-helmet'

const DataCollection = () => {
  const { patient_id } = useParams()
  const navigate = useNavigate()
  const { baseUrl, currentUser, extendCookie, setLoginShow } =
    useContext(AuthContext)
  const sessionFromCookie = Cookies.get('session')
  const { session = '' } = sessionFromCookie
    ? JSON.parse(sessionFromCookie)
    : {}

  const [activeTab, setActiveTab] = useState('blood-pressure')
  const [timeRange, setTimeRange] = useState('week')
  const [dateRange, setDateRange] = useState({
    startDate: '',
    endDate: '',
  })
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const [showAddForm, setShowAddForm] = useState(false)
  const [selectedDate, setSelectedDate] = useState('')
  const [patientName, setPatientName] = useState('')
  const getPatientInfo = '/api/crm/project/patient/getPatientInfo'

  // 定義所有的tab選項和對應的API路徑
  const tabs = [
    {
      id: 'blood-pressure',
      label: '血壓',
      icon: 'fa-heart-pulse',
      apiPath: '/api/crm/patient/measure/getBloodPressure',
      component: BloodPressureRecord,
    },
    {
      id: 'blood-sugar',
      label: '血糖',
      icon: 'fa-droplet',
      apiPath: '/api/crm/patient/measure/getBloodSugar',
      component: BloodSugarRecord,
    },
    {
      id: 'exercise',
      label: '運動',
      icon: 'fa-person-running',
      apiPath: '/api/crm/patient/measure/getExercise',
      component: ExerciseRecord,
    },
    {
      id: 'water',
      label: '喝水',
      icon: 'fa-glass-water',
      apiPath: '/api/crm/patient/measure/getWater',
      component: WaterRecord,
    },
    {
      id: 'defecation',
      label: '排便',
      icon: 'fa-toilet',
      apiPath: '/api/crm/patient/measure/getDefecation',
      component: DefecationRecord,
    },
    {
      id: 'sleep',
      label: '睡眠',
      icon: 'fa-bed',
      apiPath: '/api/crm/patient/measure/getSleep',
      component: SleepRecord,
    },
    {
      id: 'emotion',
      label: '心情',
      icon: 'fa-face-smile',
      apiPath: '/api/crm/patient/measure/getEmotion',
      component: EmotionRecord,
    },
  ]

  // 計算日期範圍的輔助函數
  const calculateDateRange = (range) => {
    const today = new Date()
    const endDate = new Date(today)
    endDate.setDate(today.getDate())

    const startDate = new Date(today) // 創建新的日期對象避免引用問題

    switch (range) {
      case 'week':
        startDate.setDate(today.getDate() - 6)
        break
      case 'two-weeks':
        startDate.setDate(today.getDate() - 13)
        break
      case 'month':
        startDate.setMonth(today.getMonth() - 1)
        break
      default:
        return null
    }

    // 格式化日期為 YYYY-MM-DD
    const formatDate = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }

    return {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
    }
  }

  // 處理時間範圍選擇 week/two-weeks/month
  const handleTimeRangeChange = (range) => {
    setTimeRange(range)
    const newDateRange = calculateDateRange(range)
    // console.log('newDateRangeBBB', newDateRange)
    setDateRange(newDateRange)
    fetchData(range, newDateRange) // 立即獲取數據
  }

  // 處理日期範圍變更 custom
  const handleDateRangeChange = (type, value) => {
    setTimeRange('custom')
    setDateRange((prev) => ({
      ...prev,
      [type]: value,
    }))
    // fetchData('custom', dateRange)
  }

  // 處理自定義日期搜尋
  const handleCustomDateSearch = () => {
    if (dateRange.startDate && dateRange.endDate) {
      setTimeRange('custom')
      fetchData('custom', dateRange)
    }
  }

  const fetchData = async (selectedTimeRange, selectedDateRange) => {
    // console.log('???', selectedDateRange)
    try {
      setIsLoading(true)
      setError(null)

      if (!session) {
        setLoginShow(true)
        throw new Error('Session not found')
      }

      const currentTab = tabs.find((tab) => tab.id === activeTab)

      const response = await axios.post(
        `${baseUrl}${currentTab.apiPath}`,
        {
          patient_id,
          start_date: selectedDateRange.startDate,
          end_date: selectedDateRange.endDate,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
            session: currentUser?.session || session || '',
          },
        }
      )

      if (response.data.data) {
        console.log(currentTab.label, response.data.data)
        extendCookie()
        setData(response.data.data)
      } else if (response.data.error?.code === '50004') {
        setLoginShow(true)
        throw new Error('Session expired')
      }
    } catch (error) {
      console.error('Error fetching data:', error)
      setError('獲取數據時發生錯誤')
    } finally {
      setIsLoading(false)
    }
  }

  // 定義tab與元件的對應關係
  useEffect(() => {
    // 取得姓名
    const fetchPatientInfo = async () => {
      try {
        setIsLoading(true)

        if (!session) {
          setLoginShow(true)
          throw new Error('Session not found or expired')
        }
        const response = await axios.post(
          baseUrl + getPatientInfo,
          { patient_id },
          {
            headers: {
              'Content-Type': 'application/json',
              Accept: '*/*',
              session: currentUser?.session || session || '',
            },
          }
        )

        // console.log('fetchPatientData', response)

        if (response.data?.name) {
          extendCookie()
          setPatientName(response.data.name)
        } else if (response.data?.error?.code === '50004') {
          alert('登入已逾時，請重新登入')
          setLoginShow(true)
        }
      } catch (error) {
        console.error('Error fetching patient data:', error)
      } finally {
        setIsLoading(false)
      }
    }

    if (session) {
      const weekRange = calculateDateRange('week')
      setDateRange(weekRange)
      fetchData('week', weekRange)
      fetchPatientInfo()
    } else {
      setLoginShow(true)
    }
  }, [activeTab])

  // tab 切換
  const handleTabChange = (selectedTab) => {
    setActiveTab(selectedTab)
    // setData(null)
    console.log('selectedTab5555', selectedTab)
    setTimeRange('week') // 重置為一週
    const weekRange = calculateDateRange('week')
    setDateRange(weekRange)
  }

  const handleGoBack = () => {
    navigate(-1)
  }

  // 動態渲染當前選中的紀錄元件
  const renderActiveRecord = () => {
    const currentTab = tabs.find((tab) => tab.id === activeTab)
    const RecordComponent = currentTab.component

    if (!RecordComponent) {
      return <div>找不到對應的紀錄元件</div>
    }

    if (isLoading) {
      return (
        <Container className="text-center">
          <div className="m-5">
            <ProgressBar className="m-4" animated now={100} />
            <h5 className="text-secondary">資料等待中...</h5>
          </div>
        </Container>
      )
    }

    return (
      <RecordComponent
        data={data}
        error={error}
        startDate={dateRange.startDate}
        endDate={dateRange.endDate}
        onDataUpdate={() => fetchData(timeRange, dateRange)}
        setShowAddForm={setShowAddForm}
        onAddRecord={(date) => {
          setSelectedDate(date)
          setShowAddForm(true)
        }}
      />
    )
  }

  const renderAddForm = () => {
    switch (activeTab) {
      case 'blood-pressure':
        return (
          <AddBloodPressure
            onSuccess={() => {
              setShowAddForm(false)
              fetchData(timeRange, dateRange)
            }}
            date={selectedDate}
            onCancel={() => setShowAddForm(false)}
          />
        )
      case 'blood-sugar':
        return (
          <AddBloodSugar
            onSuccess={() => {
              setShowAddForm(false)
              fetchData(timeRange, dateRange)
            }}
            date={selectedDate}
            onCancel={() => setShowAddForm(false)}
          />
        )
      case 'exercise':
        return (
          <AddExercise
            onSuccess={() => {
              setShowAddForm(false)
              fetchData(timeRange, dateRange)
            }}
            date={selectedDate}
            onCancel={() => setShowAddForm(false)}
          />
        )
      case 'water':
        return (
          <AddWater
            onSuccess={() => {
              setShowAddForm(false)
              fetchData(timeRange, dateRange)
            }}
            date={selectedDate}
            onCancel={() => setShowAddForm(false)}
          />
        )
      case 'defecation':
        return (
          <AddDefecation
            onSuccess={() => {
              setShowAddForm(false)
              fetchData(timeRange, dateRange)
            }}
            date={selectedDate}
            onCancel={() => setShowAddForm(false)}
          />
        )
      case 'sleep':
        return (
          <AddSleep
            onSuccess={() => {
              setShowAddForm(false)
              fetchData(timeRange, dateRange)
            }}
            date={selectedDate}
            onCancel={() => setShowAddForm(false)}
          />
        )
      case 'emotion':
        return (
          <AddEmotion
            onSuccess={() => {
              setShowAddForm(false)
              fetchData(timeRange, dateRange)
            }}
            date={selectedDate}
            onCancel={() => setShowAddForm(false)}
          />
        )

      default:
        return null
    }
  }

  return (
    <>
      <Helmet>
        <title>數據收集紀錄 | HA! CRM</title>
      </Helmet>
      <Container className="py-4 dataCollection">
        {/* 返回按鈕 */}
        {showAddForm ? (
          renderAddForm()
        ) : (
          <>
            <div className="mb-4">
              <Button
                variant="link"
                onClick={handleGoBack}
                className="text-decoration-none text-secondary"
              >
                <h5>
                  <i className="fa-solid fa-arrow-left me-2" />
                  返回{patientName}的個人頁面
                </h5>
              </Button>
            </div>

            <h2 className="text-center mb-4">{patientName}的數據收集紀錄</h2>

            {/* Tab導航 */}
            <Nav
              variant="pills"
              className="mb-4 justify-content-center"
              activeKey={activeTab}
              onSelect={handleTabChange}
            >
              {tabs.map((tab) => (
                <Nav.Item key={tab.id}>
                  <Nav.Link
                    eventKey={tab.id}
                    className="d-flex align-items-center"
                  >
                    <i className={`fa-solid ${tab.icon} me-2`}></i>
                    {tab.label}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>

            {/* 時間範圍選擇 */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div className="d-flex gap-2">
                <Button
                  variant={timeRange === 'week' ? 'primary' : 'outline-primary'}
                  onClick={() => handleTimeRangeChange('week')}
                >
                  過去一週
                </Button>
                <Button
                  variant={
                    timeRange === 'two-weeks' ? 'primary' : 'outline-primary'
                  }
                  onClick={() => handleTimeRangeChange('two-weeks')}
                >
                  過去兩週
                </Button>
                <Button
                  variant={
                    timeRange === 'month' ? 'primary' : 'outline-primary'
                  }
                  onClick={() => handleTimeRangeChange('month')}
                >
                  過去一個月
                </Button>
              </div>

              <div className="fw-bold">
                {dateRange.startDate} ~ {dateRange.endDate}
              </div>

              <div className="d-flex gap-2">
                <Form.Control
                  type="date"
                  value={dateRange.startDate}
                  style={{ height: 'fit-content' }}
                  onChange={(e) =>
                    handleDateRangeChange('startDate', e.target.value)
                  }
                />
                <Form.Control
                  type="date"
                  value={dateRange.endDate}
                  style={{ height: 'fit-content' }}
                  onChange={(e) =>
                    handleDateRangeChange('endDate', e.target.value)
                  }
                />
                <Button
                  variant="primary"
                  className="w-100"
                  disabled={!dateRange.startDate || !dateRange.endDate}
                  onClick={handleCustomDateSearch}
                >
                  搜尋
                </Button>
              </div>
            </div>

            {/* 渲染當前選中的紀錄元件 */}
            {renderActiveRecord()}
          </>
        )}
      </Container>
    </>
  )
}

export default DataCollection
